import { useScrollFadeIn, staggerStyle } from "@/hooks/useScrollFadeIn";

export default function AboutSection() {
  const { ref: headRef, style: headStyle } = useScrollFadeIn<HTMLDivElement>({ delay: 0 });
  const { ref: imgRef, style: imgStyle } = useScrollFadeIn<HTMLDivElement>({ delay: 0.1 });
  const { ref: textRef, style: textStyle } = useScrollFadeIn<HTMLDivElement>({ delay: 0.2 });

  return (
    <section id="about" className="py-14 md:py-32 bg-stone-50">
      <div className="max-w-5xl mx-auto px-5 md:px-10">
        <div ref={headRef} style={headStyle} className="text-center mb-8 md:mb-16">
          <p className="text-xs md:text-base tracking-[0.4em] text-amber-700 uppercase mb-2 md:mb-3">About</p>
          <h2
            className="font-en text-3xl md:text-4xl font-light text-stone-800 tracking-widest"
          >
            Profile
          </h2>
          <div className="w-10 h-px bg-amber-400 mx-auto mt-4 md:mt-5"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-7 md:gap-16 items-center">
          {/* Image */}
          <div ref={imgRef} style={imgStyle} className="relative">
            {/* モバイル：横長トリミング（中央） */}
            <div className="block md:hidden w-full h-80 overflow-hidden bg-stone-100">
              <img
                src="https://static.readdy.ai/image/7c1ae4d4fec6bc38be3e9701ed9ec762/3a6a19628368f9ee7f281b98b0bdc7a2.png"
                alt="むぎ茶"
                className="w-full h-full object-cover object-center"
              />
            </div>
            {/* デスクトップ：縦長 */}
            <div className="hidden md:block aspect-[3/4] overflow-hidden bg-stone-100">
              <img
                src="https://storage.readdy-site.link/project_files/5fc4a5c0-7993-4a64-a378-6d67b6cf5ae0/a1e4ad32-910b-4782-ab4d-1719d8636e53_-6.png?v=52dddeb7267607e385805c2422a3acd6"
                alt="むぎ茶"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute -top-3 -right-3 md:-top-4 md:-right-4 w-16 h-16 md:w-24 md:h-24 border border-amber-300"></div>
          </div>

          {/* Text */}
          <div ref={textRef} style={textStyle} className="pt-2 md:pt-0">
            <h3
              className="text-2xl md:text-3xl font-light text-stone-800 tracking-widest mb-4 md:mb-6"
            >
              むぎ茶
            </h3>
            <div className="space-y-3 md:space-y-4 text-base md:text-lg text-stone-600 leading-relaxed">
              <p>幼少期からの変態性が高じてSMの世界へ</p>
              <div className="w-8 h-px bg-stone-200 my-3 md:my-5"></div>
              <div className="space-y-2 md:space-y-3">
                <div className="flex items-start gap-3">
                  <span className="w-1.5 h-1.5 rounded-full bg-amber-500 mt-2 flex-shrink-0"></span>
                  <p>「S＆Mスナイパー」エッセイ連載</p>
                </div>
                <div className="flex items-start gap-3">
                  <span className="w-1.5 h-1.5 rounded-full bg-amber-500 mt-2 flex-shrink-0"></span>
                  <p className="whitespace-nowrap">SMクラブ３年・その後M性感４年以上経験</p>
                </div>
                <div className="flex items-start gap-3">
                  <span className="w-1.5 h-1.5 rounded-full bg-amber-500 mt-2 flex-shrink-0"></span>
                  <p>月に一度お仕置きBARのママ</p>
                </div>
                <div className="flex items-start gap-3">
                  <span className="w-1.5 h-1.5 rounded-full bg-amber-500 mt-2 flex-shrink-0"></span>
                  <p>えっちなこと、SM、フェチが大好き</p>
                </div>
              </div>
              <div className="w-8 h-px bg-stone-200 my-3 md:my-5"></div>
              <p className="font-en text-stone-500 italic text-sm md:text-base tracking-wider">
                "Only for You – Private Release Session"
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
